module.exports = __webpack_public_path__ + "static/media/FileProperties.b9637046.svg";